import { render, staticRenderFns } from "./EventsAdmin.vue?vue&type=template&id=f3928730"
import script from "./EventsAdmin.vue?vue&type=script&lang=js"
export * from "./EventsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports